import { L } from '@lib';
import { Button, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { CreditNoteCapture } from './CreditNoteCapture';

interface IProps {
  open: boolean;
  onClose: () => void;
  onAttach: (documentId: string, fileName: string) => void;
}

/**
 * Captures a single credit note (direct upload or phone QR capture) and returns its documentId.
 * One instance is reused for whichever part the user is attaching to, so only one capture
 * session is ever active at a time.
 */
export const CreditNoteModal: React.FC<IProps> = ({ open, onClose, onAttach }) => {
  const [documentId, setDocumentId] = useState<string | undefined>();
  const [fileName, setFileName] = useState<string | undefined>();
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (open) return;
    setDocumentId(undefined);
    setFileName(undefined);
  }, [open]);

  const handleAttach = () => {
    if (documentId) onAttach(documentId, fileName || 'Credit note');
  };

  return (
    <Modal
      open={open}
      title={L('Credit note')}
      width={520}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {L('Cancel')}
        </Button>,
        <Button
          key="attach"
          type="primary"
          disabled={!documentId}
          loading={uploading}
          onClick={handleAttach}
        >
          {L('Attach')}
        </Button>,
      ]}
    >
      <CreditNoteCapture
        active={open}
        fileName={fileName}
        onUploadingChange={setUploading}
        onCaptured={(captured) => {
          setDocumentId(captured.documentId);
          setFileName(captured.fileName);
        }}
      />
    </Modal>
  );
};

export default CreditNoteModal;
